export function SET_DONT_SHOW_AGAIN(state, dontShowAgain) {
  state.dontShowAgain2 = dontShowAgain;
}
